import { createSlice } from "@reduxjs/toolkit";
import { MyLessonsThunk } from "../../middlewares/myLessons";

const initialState = {
  loading: false,
  isUpdateLessons: false,
  myLessonData: [],
  currentRequestId: null,
};

const myLessonsSlice = createSlice({
  name: "myLessons",
  initialState,
  reducers: {
    isUpdateMyLessons(state) {
      state.isUpdateLessons = !state;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(MyLessonsThunk.pending, (state, action) => {
        state.currentRequestId = action.meta.requestId;
        state.loading = true;
      })
      .addCase(MyLessonsThunk.fulfilled, (state, action) => {
        if (state.currentRequestId !== action.meta.requestId) return;
        state.myLessonData = action.payload;
        state.loading = false;
        state.currentRequestId = null;
      })
      .addCase(MyLessonsThunk.rejected, (state, action) => {
        if (state.currentRequestId !== action.meta.requestId) return;
        state.loading = false;
        state.currentRequestId = null;
      });
  },
});

export const { isUpdateMyLessons } = myLessonsSlice.actions;
export default myLessonsSlice.reducer;
